import React from 'react';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { userInitialsAsString } from '../../util/data';

import { NamedLink } from '../../components';

import CollectionInterestForm from '../CollectionPage/CollectionInterestForm';
import ListPieceForSaleButton from '../CollectionPage/ListPieceForSaleButton';

import css from './CollectionPiecePanel.module.css';

/**
 * Nextmine: panelet på et samlingsstykkes egen side.
 *
 * Et samlingsstykke kan ikke købes, så den almindelige købsboks giver ingen
 * mening her - den ville love en handel, der ikke findes. I stedet fortæller
 * panelet hvis samling stykket hører til, fører videre til resten af
 * samlingen, og lader en besøgende sige at hun er interesseret.
 *
 * Ejeren ser det modsatte: vejen ud af samlingen, hvis hun har skiftet mening.
 *
 * Siden findes fordi hvert stykke skal kunne deles og findes i søgemaskiner;
 * selve oplevelsen ligger på samlingssiden.
 *
 * @param {Object} props
 * @param {Object} props.listing samlingsstykket (inkl. author)
 * @param {boolean} props.isOwnListing er den nuværende bruger ejeren
 * @param {boolean} props.isAuthenticated
 * @param {React.Node} props.titleDesktop overskrift til desktop
 */
const CollectionPiecePanel = props => {
  const { className, rootClassName, listing, isOwnListing, isAuthenticated, titleDesktop } = props;
  const intl = useIntl();

  const author = listing?.author;
  const authorId = author?.id?.uuid;
  const collectorName =
    userInitialsAsString(author, '') ||
    intl.formatMessage({ id: 'CollectionPiecePanel.collectorFallback' });

  return (
    <div className={classNames(rootClassName || css.root, className)}>
      {titleDesktop}

      <p className={css.eyebrow}>
        <FormattedMessage id="CollectionPiecePanel.fromCollection" />
      </p>

      {authorId ? (
        <NamedLink className={css.collectionLink} name="CollectionPage" params={{ id: authorId }}>
          <FormattedMessage
            id="CollectionPiecePanel.seeCollection"
            values={{ name: collectorName }}
          />
        </NamedLink>
      ) : null}

      <p className={css.note}>
        <FormattedMessage id="CollectionPiecePanel.notForSale" values={{ name: collectorName }} />
      </p>

      {isOwnListing ? (
        <>
          <ListPieceForSaleButton className={css.sellSection} piece={listing} />
          <NamedLink className={css.manageLink} name="MyCollectionPage">
            <FormattedMessage id="CollectionPiecePanel.manage" />
          </NamedLink>
        </>
      ) : (
        <CollectionInterestForm
          piece={listing}
          collectorName={collectorName}
          isAuthenticated={isAuthenticated}
        />
      )}
    </div>
  );
};

export default CollectionPiecePanel;
